export const enum EInviteBuyerType {
    BUYER_INVITATION = "buyer_invitation",
}

export enum EInvitationStatus {
    PENDING = "pending",
    SENT = "sent",
    ACCEPTED = "accepted",
    CANCELED = "canceled",
    EXPIRED = "expired",
    FAILED = "failed",
}
